import { connect } from 'react-redux';
import BranchSelector from './BranchSelector';
import { hideModal, selectBranch } from '../../stateManagement/engine/actions/SessionActions';
import { Modals } from '../../utils/constants';

function mapStateToProps(state) {
  return {
    organizations: state.session.branches,
    isListLoading: state.session.loadingBranches,
    isSubmitButtonLoading: state.session.loadingOrganization,
    baseLocation: state.order.address,
    initialValue: state.session.organization.id,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: payload => dispatch(selectBranch(payload)),
    onCancel: () => dispatch(hideModal({ modal: Modals.BRANCH_SELECTOR })),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BranchSelector);
